import { Entity } from '@backstage/catalog-model';
import { Select } from '@backstage/core-components';
import { DefaultEntityFilters, EntityFilter, useEntityList } from '@backstage/plugin-catalog-react';
import { Box } from '@material-ui/core';
import { useEffectOnce } from 'react-use';


class EntitySubDomainFilter implements EntityFilter {
  constructor(readonly value: string) { }
  filterEntity(entity: Entity): boolean {
    if (entity.kind !== 'Domain') return true;
    const hasPartOfRelation = entity.relations?.some(a => a.type === 'partOf') || false;
    if (this.value === 'parent') return !hasPartOfRelation;
    if (this.value === 'subdomain') return hasPartOfRelation;
    return true;
  }
}

type CustomFilters = DefaultEntityFilters & {
  domainShowOptions?: EntitySubDomainFilter;
};

type EntitySubDomainPickerProps = {
  initialFilter: string;
};

export const EntitySubDomainPicker = ({ initialFilter }: EntitySubDomainPickerProps) => {
  const { filters: { kind }, updateFilters } = useEntityList<CustomFilters>();

  useEffectOnce(() => {
    updateFilters({ domainShowOptions: new EntitySubDomainFilter(initialFilter) });
  });

  function onChange(value: string) {
    updateFilters({ domainShowOptions: new EntitySubDomainFilter(value) });
  }

  const options = [
    { label: 'All', value: 'all' },
    { label: 'Parent Domains', value: 'parent' },
    { label: 'Subdomains', value: 'subdomain' },
  ];

  return (
    <Box hidden={kind?.value !== 'domain'}>
      <Select
        items={options}
        label="SUBDOMAIN FILTER"
        selected={initialFilter}
        onChange={(selected) => onChange(selected.toString())}
      />
    </Box>
  );
};

